import classNames from 'classnames';
import type { Delta } from 'quill/core';
import React from 'react';
import * as styles from './FacetedSearchInput.module.scss';
import SearchInput from './SearchInput';
import { useAppDispatch } from '../app/redux/useAppSelector';
import IconButton from '../components/IconButton';
import SVGIcon from '../components/SVGIcon';
import SearchOptionsModal from '../help/SearchOptionsModal';
import informationIcon from '../icons/non-prefilled/16x16/information.svg';
import searchIcon from '../icons/non-prefilled/16x16/search.svg';
import { UIActions } from '../ui/uiSlice';

interface FacetedSearchInputProps {
  expanded?: boolean;
  placeholder?: string;
  onChange?: (content: Delta) => void;
  onEnter?: () => void;
  content?: Delta;
}

const FacetedSearchInput = ({
  expanded,
  placeholder,
  onChange,
  onEnter,
  content,
}: FacetedSearchInputProps) => {
  const dispatch = useAppDispatch();

  const showSearchOptions = () => {
    dispatch(UIActions.openModal(SearchOptionsModal));
  };

  return (
    <div
      className={classNames(styles.container, {
        [styles.expanded]: expanded,
      })}
    >
      <SVGIcon className={styles.icon}>{searchIcon}</SVGIcon>
      <SearchInput
        placeholder={placeholder}
        onChange={onChange}
        initialContent={content}
        onEnter={onEnter}
      />
      <IconButton
        className={classNames(styles.infoIcon, { [styles.shown]: expanded })}
        onClick={showSearchOptions}
        aria-label="Show search filter options"
      >
        {informationIcon}
      </IconButton>
    </div>
  );
};

export default FacetedSearchInput;
